<template>
  <div v-show="visible">
    <div class="popup_wrap editAttributePool">
      <div class="popup_title">
        <p><span id="node_title">속성POOL 수정</span></p>
        <a>
          <div id="popup_close" class="btn_close" title="Close" @click="close"><div class="btn_close_box"><span></span><span></span></div></div>
        </a>
      </div><!-- //popup_title -->
      <div class="popup_content1">
        <div class="node_order_wrap">
          <div class="node_order_box_left">
            <p style="color: red; font-size: 12px;">
              ※주의※<br/>
              속성POOL 일괄수정 시 해당 속성POOL 속성을 적용중인 모든 공정도 속성에도 적용됩니다.
            </p>
            <table width="100%" border="0" cellspacing="0" cellpadding="0" class="board_node">
              <colgroup>
                <col width="30%">
                <col width="*">
              </colgroup>
              <tbody>
            <tr>
                <th style="vertical-align: middle">수정범위</th>
                <td>
                    <label for="relatedModify_True">
                        <input type="radio" name="relatedModify" id="relatedModify_True" value="true" v-model="relatedModify"/>
                        <span>일괄수정</span>
                    </label>
                    <label for="relatedModify_False">
                          <input type="radio" name="relatedModify" id="relatedModify_False" value="false" v-model="relatedModify"/>
                          <span>현재속성만</span>
                      </label>
                </td>
              </tr>
              <tr>
                <th style="vertical-align: middle">속성명</th>
                <td>
                    <input type="text" data-key="target" v-model="target.propertyName"
                           @input="inputListener($event,'propertyName')" @keydown="keydownListener($event,'propertyName')">
                </td>
              </tr>
              <tr v-if="!isDistrictValid.includes(target.propertyType)">
                <th style="vertical-align: middle">속성기본값</th>
                <td>
                    <input type="text" data-key="target" v-model="target.propertyValue"
                           @input="inputListener($event,'propertyValue')" @keydown="keydownListener($event,'propertyValue')">
                </td>
              </tr>
            <tr>
              <th style="vertical-align: middle">속성단위</th>
              <td>
                  <input
                          type="text"
                          style="margin-right: 10px;"
                          :readonly="!isEditingPropertyUnit"
                          :value="propertyUnitValue"
                          @click="startEditPropertyUnit"
                          @input="onPropertyUnitInput($event)"
                  >
              </td>
            </tr>
            <tr>
              <th style="vertical-align: middle">어휘번호</th>
              <td>
                  <VocabularyAutocomplete
                    @select="handleVocabularySelect"
                    :selectedVocabularyId="String(target.propertyVocabularyId)"
                  />
              </td>
            </tr>
            <tr>
              <th style="vertical-align: middle">class</th>
              <td>
                <select data-key="target" v-model="target.propertyClassId" @change="inputListener($event,'propertyClassId'); target.propertyClass = getPropertyClassList.find(c=>c?.id==target.propertyClassId)">
                  <option v-for="(propertyclass, index) in getPropertyClassList" 
                          :key="index" 
                          :value="propertyclass?.id">{{propertyclass?.name}}</option>
                </select>
              </td>
            </tr>
              <tr>
                <th style="vertical-align: middle">속성설명</th>
                <td>
                    <textarea type="text" data-key="target" v-model="target.propertyDefine" rows="10"
                           @input="inputListener($event,'propertyDefine')" @keydown="keydownListener($event,'propertyDefine')"/>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="popup_footer">
        <a class="btn_type1" @click="saveDictionaryProperty">수정</a>
        <a class="btn_type3" @click="close">닫기</a>
      </div>
    </div>
    <div class="mask_wrap" style="display:block; z-index:1000;"></div>
    <Loading :visible="loading" type="fixed"/>
  </div>
</template>

<script>
import Loading from '@common/loading.vue';
import VocabularyAutocomplete from '@components/common/inputs/VocabularyAutocomplete.vue';
import {createNamespacedHelpers} from 'vuex';
import {districtType} from '@/util/HubHandsonTable';
const Hub = createNamespacedHelpers('Hub');

export default {
  data() {
    return {
      loading : null,
      visible : false,
      target : {},
      relatedModify : true,
      isForceReleaseFlag : false,
      isUnitModifiedByAdmin : false,
      isEditingPropertyUnit : false,
      changePropertyUnitValue : null,
    }
  },
  components: {
    Loading,
    VocabularyAutocomplete,
  },
  computed: {
    // Hub 모듈의 Getters
    ...Hub.mapGetters([
      'getAttributePoolObj',
      'getSelectedNode',
      'getPropertyClassList',
      'getVocabularyList',
    ]),
    isDistrictValid() {
      return districtType();
    },
    propertyUnitValue(){
      if(!this.isEditingPropertyUnit) {
        return this.target.propertyUnit;
      }else{
        return this.changePropertyUnitValue;
      }
    },
  },
  watch: {
    getAttributePoolObj: {
      deep: true,
      async handler(value) {
        if (value.attrPoolPopFlag === true && typeof value.attrPoolInfo == 'object') {
          this.show();
          this.target = value.attrPoolInfo;
        } else if (value.attrPoolPopFlag === false) {
          this.visible = false;
          this.target = {};
          this.relatedModify = true;
        }
      }
    },
  },
  async mounted() {
  },
  methods: {
    ...Hub.mapMutations(
        [
          "setAttributePoolObj",
        ]
    ),
    ...Hub.mapActions(
        [
          "updateSelectedNode",
          "fetchPropertyClassList",
          "fetchVocabularyList",
        ]
    ),
    handleVocabularySelect(selectedItem) {
      if(selectedItem != null) {
        this.target.propertyVocabularyId = String(selectedItem.id);
        this.target.propertyVocabulary = selectedItem;
      }else{
        this.target.propertyVocabularyId = null;
        this.target.propertyVocabulary = null;
      }
    },
    onPropertyUnitInput(event){
      this.changePropertyUnitValue = event.target.value;
    },
    async startEditPropertyUnit(){
      this.loading = true;
      let checkData = await this.$wApi.experiment.getExperimentDataByPropertyAndProcess({
        processId: this.$route.query.processId
        , dictionaryPropertyId: this.target.dictionaryPropertyId
      });
      if (checkData) {
        if(this.user.admin){
          this.isUnitModifiedByAdmin = true;
        }
        if (checkData.find(data => data.value != null && data.value != "" && data.value.trim() != "")) {
          if (this.user.admin) {//데이터가 존재하는 경우 관리자만 수정할 수 있다.
            this.changePropertyUnitValue = this.target.propertyUnit;
            this.isEditingPropertyUnit = true;
            this.isForceReleaseFlag = true;
          } else {
            this.loading = false;
            await window.alert("해당 속성에 작성된 데이터가 이미 존재하여 수정할 수 없습니다.<br>자세한 내용은 관리자에게 문의하세요.");
            return;
          }
        } else {
          this.changePropertyUnitValue = this.target.propertyUnit;
          this.isEditingPropertyUnit = true;
          this.isForceReleaseFlag = true;
        }
      } else { //여기는 강제로 공개하지 않는다.
        this.changePropertyUnitValue = this.target.propertyUnit;
        this.isEditingPropertyUnit = true;
        this.isForceReleaseFlag = false;
      }
      this.loading = false;
    },
    async savePropertyUnit(){
      let confirmMsg = "";
      const releaseProcess = await this.$wApi.process.release.get({processId : this.$route.query.processId});
      let confirm = true;
      if(releaseProcess.idReleaseProcess!=null) { // 이미 공개된 정보가 있는 경우에만 안내를 하며 진행한다.
        if (this.isUnitModifiedByAdmin) { 
          confirmMsg = `단위를 수정하면 현재 공정도가 공개되며, 변경 내용이 즉시 반영됩니다.<br><span style="color:red;">기존 데이터는 새로운 단위에 맞게 직접 수정해야 합니다.</span><br>계속 진행하시겠습니까?`;
        } else {
          confirmMsg = `단위를 수정하면 현재 공정도가 공개되며, 변경 내용이 즉시 반영됩니다.<br>계속 진행하시겠습니까?`;
        }
        confirm = await window.confirm(confirmMsg);
      }
      if(confirm) {
        this.loading = true;
        let response = await this.$wApi.property.updatePropertyUnit({
          processId: this.$route.query.processId
          , dictionaryPropertyId: this.target.dictionaryPropertyId
          , changePropertyUnitValue: this.changePropertyUnitValue
          , forceReleaseFlag: this.isForceReleaseFlag
          , relatedModify: this.relatedModify
        });
        if(response.error){
          this.loading = false;
          await window.alert("단위 수정 중 오류가 발생했습니다.<br>잠시 후 다시 시도해 주세요.");
        }else{
          this.target.propertyUnit = this.changePropertyUnitValue;
          this.isEditingPropertyUnit = false
          this.loading = false;
          await window.alert("단위 수정이 완료되었습니다.");
        }
      }else{
        this.isForceReleaseFlag=false;
        this.isUnitModifiedByAdmin=false;
        this.isEditingPropertyUnit=false;
        this.changePropertyUnitValue=null;
        await window.alert("단위 수정이 취소되었습니다.");
      }
    },
    async saveDictionaryProperty(){
      try {
        if(this.target == null && this.target.dictionaryPropertyId != null && this.target.dictionaryPropertyId != ''){
          await window.alert("오류가 발생하였습니다.<br>관리자에게 문의바랍니다.");
        }

        if(JSON.parse(this.relatedModify)){
          const flag = await window.confirm("속성을 수정하시겠습니까?<br>수정 시 해당 속성을 참조하는 모든 공정도 속성도 수정됩니다.");
          if(!flag) return;
        }

        this.loading = true;
        if(this.isEditingPropertyUnit){
          await this.savePropertyUnit();
          this.loading = true;
        }
        const response = await this.$wApi.property.updateRelatedProperty({...this.target, relatedModify : this.relatedModify});
        if(!response.error){
          await window.alert("속성이 수정되었습니다.");
          //새로고침
          await this.updateSelectedNode({
            ...this.getSelectedNode
          });
          this.close();
        }
      }catch (e) {
        await window.alert(e);
      }finally {
          this.loading = false;
      }
    },
    inputListener(v,id) {
      const target = v.target.getAttribute('data-key');
      switch (target){
        default :
          this[target][id] = v.target.value;
          break;
      }
    },
    keydownListener(v,id) {
      const target = v.target.getAttribute('data-key');
      switch (target){
        default :
          this[target][id] = v.target.value;
          break;
      }
    },
    async show() {
      this.visible = true;
      await this.$nextTick();
      await this.fetchPropertyClassList();
      await this.fetchVocabularyList();
    },
    close() {
      this.isEditingPropertyUnit=false;
      this.changePropertyUnitValue=null;
      this.setAttributePoolObj({
        openFlag: false,
        dataObj: {}
      });
    },
  }
}
</script>

<style lang="scss">
@import "@/style/new/css/cyl.common.css";
.editAttributePool  {display:block;position:fixed; width:500px;height:60%;  left:50%;top:50%;transform:translate(-50%,-50%); z-index:1001; box-shadow:5px 5px 20px 0px rgba(0,0,0,0.2);}
@media screen and (max-width: 1250px) {
  .editAttributePool {width:95%;}
}
</style>